// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { listStyles } from "@sc/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

listStyles.wrapper = {};

listStyles.cardList = {
    gridContainer: {
        gap: 22,
        css: css`
            ${xScreen("lte", "md")} {
                border-bottom: 1px solid ${getColor("common.border")};
            }
            ${xScreen("lte", "sm")} {
                border-bottom: none;
            }
            &[data-test-selector="productListCards_List"] {
                padding-bottom: 11px;
                ${xScreen("lte", "md")} {
                    padding-bottom: 24px;
                }

                & > div {
                    margin-top: 0;
                    justify-content: flex-start;
                    ${xScreen("lte", "sm")} {
                        padding: 0 11px;
                        justify-content: center;
                    }
                }
            }
            &[data-test-selector="productListCards_Grid"] {
                border-bottom: 1px solid ${color("common.border")};
                padding-bottom: 24px;
                & > div {
                    margin-top: 0;
                }
            }
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            border: none;
            margin: 0;
            width: 100%;
            padding: 0;
            ${xScreen("lte", "md")} {
                width: 50%;
                border-bottom: none;
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
                border-bottom: 1px solid ${color("common.border")};
                margin-right: 11px;
                &:last-child {
                    padding-bottom: 8px;
                }
            }
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${xScreen("lte", "md")} {
                height: 100%;
            }
            ${xScreen("lte", "sm")} {
                padding: 0;
            }
        `,
    },
};
listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            border: none;
            height: 100%;
            padding: 0;
        `,
    },
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            padding: 11px;
            ${xScreen("lte", "md")} {
                &:nth-child(2n) {
                    justify-content: flex-end;
                }
            }
            ${xScreen("lte", "sm")} {
                &:nth-child(2n) {
                    justify-content: flex-start;
                }
            }
        `,
    },
};
